export default {
  STRIPE_KEY: process.env.REACT_APP_STRIPE_KEY,
  RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  GA_TRACKING_ID: process.env.REACT_APP_GA_TRACKING_ID,
  LINKEDIN_PARTNERID: process.env.REACT_APP_LINKEDIN_PARTNERID,
};
